import { Component, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "landing-slide-form",
  templateUrl: "./landing-slide-form.component.html",
  styleUrls: ["./landing-slide-form.component.scss"],
})
export class LandingSlideFormComponent {
  @Input() form: FormGroup;

  modes: Array<Object> = [];
  backgroundPositions: Array<Object> = [];

  constructor(public ft: FormToolsService) {
    this.modes = [
      { value: "img-txt", label: "Imagen - Texto" },
      { value: "txt-img", label: "Texto - Imagen" },
      { value: "img", label: "Solo Imagen" },
      { value: "txt", label: "Solo Texto" },
    ];

    this.backgroundPositions = [
      { value: "top", label: "Arriba" },
      { value: "bottom", label: "Abajo" },
      { value: "left", label: "Izquierda" },
      { value: "right", label: "Derecha" },
      { value: "center", label: "Centro" },
    ];
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/landings/landing-slide-form/landing-slide-form.component.ts